var map = {
	"./buildJobstreetLocalisation": 56540,
	"./buildJobstreetLocalisation.ts": 56540,
	"./en-id": 50,
	"./en-id.ts": 50,
	"./en-my": 34586,
	"./en-my.ts": 34586,
	"./en-ph": 81914,
	"./en-ph.ts": 81914,
	"./en-sg": 6992,
	"./en-sg.ts": 6992,
	"./id-id": 18287,
	"./id-id.ts": 18287,
	"./partners": 31353,
	"./partners.ts": 31353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94453;